/* eslint-disable no-param-reassign */ // reanimated shared values are mutable
export function setOriginalXYAccordingToPosition(originalX, originalY, position, // from 0 to 1
data) {
    'worklet';
    let idx = 0;
    let smallestDistance = +Infinity;
    for (let i = 0; i < data.length; i++) {
        const distance = Math.abs(i / (data.length - 1) - position);
        if (distance > smallestDistance) {
            idx = i - 1;
            break;
        }
        smallestDistance = distance;
        if (i === data.length - 1) {
            idx = data.length - 1;
        }
    }
    if (!data[idx]) {
        // prevent the following error on android:
        // java.lang.RuntimeException: undefined is not an object (evaluating 'data[idx].originalX')
        // why data = [] sometimes onActive?
        // eslint-disable-next-line no-console
        console.warn('No data available for chart', data.length, idx);
        return;
    }
    originalX.value = Math.round(data[idx].originalX).toString();
    // originalX.value = idx.toString();
    const y = data[idx].originalY;
    originalY.value = y ? y.toString() : 'undefined';
}
export function positionXWithMargin(x, margin, width) {
    'worklet';
    if (x < margin) {
        return Math.max(3 * x - 2 * margin, 0);
    }
    if (width - x < margin) {
        return Math.min(margin + x * 2 - width, width);
    }
    return x;
}
